
export const MCP_TOOL_AGENTS = ['microsoft-exchange', 'linkedin', 'elevenlabs'] as const;
export type MCPToolAgentId = typeof MCP_TOOL_AGENTS[number];

export interface MCPToolAgentHooks {
  microsoftExchange: { callMethod: (method: string, params: any) => Promise<any>; };
  linkedin: { callMethod: (method: string, params: any) => Promise<any>; };
  elevenlabs: { callMethod: (method: string, params: any) => Promise<any>; };
}
